var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ _vm.baseClass, _vm.padding, { 'items-center' : _vm.center }]},[_c('dt',{class:[ _vm.termClass, _vm.termCol ]},[_vm._t("term",function(){return [_vm._v("\n      "+_vm._s(_vm.term)+"\n    ")]})],2),_vm._v(" "),_c('dd',{class:[ _vm.definitionClass, _vm.definitionCol, { 'text-right' : _vm.alignRight } ]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }